import React from "react";
import { stack as Menu } from "react-burger-menu";
import "../../css/HamburgerMenu.css";
import { Link } from "react-router-dom";

export default class Sidebar extends React.PureComponent<{}, {}> {
  render() {
    return (
      <Menu>
        <Link className="menu-item" to="/">
          <i className="fas fa-house-user"></i>Home
        </Link>
        <Link className="menu-item" to="/weather">
          <i className="fas fa-cloud-moon-rain"></i>Weather
        </Link>
        <Link className="menu-item" to="/news">
          <i className="fas fa-newspaper"></i>News
        </Link>
        <Link className="menu-item" to="/advice">
          <i className="fas fa-smile-wink"></i>Random Joke & Advice
        </Link>
        <Link className="menu-item" to="/gifs">
          <i className="fas fa-image"></i>GIFS
        </Link>
        <Link className="menu-item" to="/words">
          <i className="fas fa-book"></i>Words
        </Link>
      </Menu>
    );
  }
}
